import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';

export const expandoStyle: React.CSSProperties = {
    marginLeft: CommonStyles.Sizes.DefaultSpace,
    marginTop: CommonStyles.Sizes.SmallSpace
};
